module.exports = __webpack_public_path__ + "static/media/bulb_1.b4ca6fe8.png";